import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
 *  Home Message Banner
 *    Simple intersection observer script add a class to when section visible.
 *
 *  Version:
 *    1.0.0 - 2021/11/09
 */

export {};
var SELECTOR_CONTAINER = '[data-home-message]';
var CLASS_IS_VISIBLE = 'is-section-visible';
var observer = new IntersectionObserver(function (entries) {
  entries.forEach(function (entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add(CLASS_IS_VISIBLE);
    } else {
      entry.target.classList.remove(CLASS_IS_VISIBLE);
    }
  });
}, {
  threshold: .4
});
var containerElements = document.querySelectorAll(SELECTOR_CONTAINER);
containerElements.forEach(function (container) {
  return observer.observe(container);
});